import { render, staticRenderFns } from "./PhotographComponent.vue?vue&type=template&id=f4abc6ba&scoped=true&"
import script from "./PhotographComponent.vue?vue&type=script&lang=js&"
export * from "./PhotographComponent.vue?vue&type=script&lang=js&"
import style0 from "./PhotographComponent.vue?vue&type=style&index=0&id=f4abc6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4abc6ba",
  null
  
)

export default component.exports